export const ROLE_STYLES: Record<string, { color: string; bg: string }> = {
  TEACHER: { color: '#1d4ed8', bg: '#dbeafe' },
  STUDENT: { color: '#059669', bg: '#d1fae5' },
  ADMIN: { color: '#7c3aed', bg: '#ede9fe' },
  SUPER_ADMIN: { color: '#dc2626', bg: '#fee2e2' },
};

export const USER_ROLES = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  ADMIN: 'ADMIN',
  TEACHER: 'TEACHER',
  STUDENT: 'STUDENT',
} as const;

export const STATUS_COLORS: Record<string, string> = {
  ACTIVE: '#10b981',
  INACTIVE: '#94a3b8',
  SUSPENDED: '#ef4444',
  REJECTED: '#dc2626',
  PENDING_APPROVAL: '#f59e0b',
  PENDING_VERIFICATION: '#f59e0b',
};

export const USER_STATUSES = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  SUSPENDED: 'SUSPENDED',
} as const;

export const ASSIGNMENT_STATUS_COLORS: Record<string, { color: string; bg: string }> = {
  PENDING: { color: '#f59e0b', bg: '#fef3c7' },
  IN_PROGRESS: { color: '#3b82f6', bg: '#dbeafe' },
  COMPLETED: { color: '#10b981', bg: '#d1fae5' },
};

export const AVATAR_COLORS = [
  '#ef4444', '#f97316', '#f59e0b', '#84cc16',
  '#22c55e', '#14b8a6', '#06b6d4', '#3b82f6',
  '#6366f1', '#8b5cf6', '#d946ef', '#ec4899',
];

export const BOARD_OPTIONS = ['CBSE', 'ICSE', 'IB', 'State', 'Other'] as const;

export const GRADES = [
  'Kindergarten',
  ...Array.from({ length: 12 }, (_, i) => `Grade ${i + 1}`),
];

export const PAGE_SIZE = 20;
export const DEBOUNCE_DELAY = 300;

export const API_ENDPOINTS = {
  AUTH_LOGIN: '/auth/login',
  AUTH_REGISTER: '/auth/register',
  AUTH_REFRESH: '/auth/refresh',
  AUTH_CHANGE_PASSWORD: '/auth/password/change',
  USERS_ME: '/users/me',
  TEACHER_STUDENTS: '/teachers/me/students',
  TEACHER_INVITE: '/teachers/me/invite',
  INVITE_STUDENT: '/users/invite',
  STUDENT_JOIN: '/students/join',
  STUDENT_TEACHERS: '/students/me/teachers',
  STUDENT_DECKS: '/students/decks',
  DECKS: '/decks',
  SESSIONS: '/sessions',
  UPLOAD_IMAGE: '/upload/image',
  ANALYTICS_OVERVIEW: '/analytics/overview',
  ANALYTICS_DECKS: '/analytics/decks',
  ANALYTICS_STUDENTS: '/analytics/students',
  CURRICULUM_BOARDS: '/curriculum/boards',
  CURRICULUM_SUBJECTS: '/curriculum/subjects',
  CURRICULUM_CHAPTERS: '/curriculum/chapters',
  CONNECTIONS: '/users/connections',
  IMPORT_PARSE: '/import/parse',
  IMPORT_PREVIEW: '/import/preview',
  IMPORT_COMMIT: '/import/commit',
  IMPORT_UPLOAD: '/import/upload',
  MY_NOTIFICATIONS: '/users/me/notifications',
  LIBRARY_QUESTIONS: '/library/questions',
  LIBRARY_SUBMIT: '/library/questions/submit',
  LIBRARY_IMPORT: '/library/questions/import',
  LIBRARY_MY_SUBMISSIONS: '/library/questions/my-submissions',
  ADMIN_LIBRARY_QUESTIONS: '/admin/library/questions',
  ADMIN_LIBRARY_STATS: '/admin/library/stats',
  HELP_REQUESTS: '/help-requests',
  HELP_REQUESTS_MY: '/help-requests/my',
  STUDENT_PROGRESS: '/students/me/progress',
  STUDENT_BADGES: '/students/me/badges',
  AI_CHAT: '/ai/chat',
  AI_USAGE: '/ai/usage',
} as const;
